'use client'

import useUser from 'components/hooks/use-user';
import { Cart } from 'lib/bigcommerce/types';
import { Customer } from 'lib/bigcommerce/types/customer';
import { usePathname, useSearchParams } from 'next/navigation';
import React, { MutableRefObject, useEffect } from 'react';
import { FunnelData } from 'shared-react-components';
import * as gtm from '../analytics/gtm';
import useCart from './use-cart';
import useSessionId from './use-session-id';

const prevPathname = React.createRef<string | undefined>() as MutableRefObject<string | undefined>;
const prevSearchParams = React.createRef<string | undefined>() as MutableRefObject<string | undefined>;

export default function useGtm({ funnelData, onReady }: { funnelData?: FunnelData, onReady?: (user?: Customer, cart?: Cart) => void }) {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const sessionId = useSessionId();
  const { user, loading: userLoading } = useUser();
  const { cart, loading: cartLoading } = useCart();
  const ready = !userLoading && !cartLoading;

  useEffect(() => {
    if (ready) {
      setTimeout(() => {
        gtm.baseGtmData({
          customer: user,
          sessionId,
          funnelData
        });
  
        gtm.pageView({
          prevPathname: prevPathname.current ?? '',
          prevSearchParams: prevSearchParams.current ?? '',
          pathname: pathname ? pathname : '',
          searchParams: searchParams ? searchParams.toString() : '',
          funnelData
        });
  
        onReady && onReady(user, cart);

        prevPathname.current = pathname ? pathname : undefined;
        prevSearchParams.current = searchParams?.toString();
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, sessionId, ready])

  return null;
}
